export default __webpack_public_path__ + "static/media/button.9993bdcc.png";